import { RootState } from "@/app/store/type";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type ModalFeedbackType = 'application' | 'presentation' | 'selection'

type InitialState = {
    opened: boolean,
    type?: ModalFeedbackType,
    link?: string
}

const initialState: InitialState = {
    opened: false
};

const modalSlice = createSlice({
    name: 'modal',
    initialState,
    reducers: {
        openFeedBackModal: (state, actions: PayloadAction<{
            type: ModalFeedbackType,
            link?: string
        }>) => {
            return state = {
                opened: true,
                type: actions.payload.type,
                link: actions.payload.link,
            }
        },
        closeFeedBackModal: (state) => {
            return state = { opened: false };
        }
    },
});

export const selectModalOpened = (state: RootState) => state.modal.opened;
export const selectModalFeedbackType = (state: RootState) => state.modal.type;
export const selectModalFeedbackLink = (state: RootState) => state.modal.link;

export const { openFeedBackModal, closeFeedBackModal } = modalSlice.actions;
export default modalSlice.reducer;
